import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";

// Layout Components
import Header from "./components/layout/Header";
import Footer from "./components/layout/Footer";

// Section Components
import HeroSection from "./components/sections/HeroSection";
import AboutSection from "./components/sections/AboutSection";
import ServicesSection from "./components/sections/ServicesSection";
import EngagementSection from "./components/sections/EngagementSection";
import IndustriesSection from "./components/sections/IndustriesSection";
import ClientsSection from "./components/sections/ClientsSection";
import TeamSection from "./components/sections/TeamSection";
import GovernanceSection from "./components/sections/GovernanceSection";
import ContactSection from "./components/sections/ContactSection";

const HomePage = () => {
  return (
    <main>
      <HeroSection />
      <AboutSection />
      <ServicesSection />
      <IndustriesSection />
      <EngagementSection />
      <ClientsSection />
      <TeamSection />
      <GovernanceSection />
      <ContactSection />
    </main>
  );
};

function App() {
  return (
    <div className="App bg-[#1a1c1b] min-h-screen">
      <BrowserRouter>
        <Header />
        <Routes>
          <Route path="/" element={<HomePage />} />
        </Routes>
        <Footer />
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
